import { render } from "./BalanceTransactions.vue?vue&type=template&id=5d85a0a1"
import script from "./BalanceTransactions.vue?vue&type=script&lang=js"
export * from "./BalanceTransactions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__